import { joinPoints } from '@/mocks/homeData';

export default function JoinCta() {
  return (
    <section id="join" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20coral%20orange%20and%20deep%20green%20geometric%20waves%20with%20soft%20grain%20texture%2C%20minimal%20modern%20poster%20background%2C%20moody%20deep%20tones%20for%20text%20overlay%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=guamelon-join-2026&orientation=landscape"
          alt="1每日吃瓜 入口"
          title="1每日吃瓜 新鲜爆料入口"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/35"></div>
      </div>

      <div className="relative mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1.5 text-xs font-bold text-white">
              <i className="ri-download-2-line"></i>
              入口 · 更方便追瓜
            </span>
            <h2 className="mt-4 font-heading text-3xl leading-tight text-white md:text-4xl">
              把 1每日吃瓜 放到手边，新瓜第一时间到
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
              打开入口就能看到今日更新，收藏、追话题、看作息表都在同一个地方。不用来回翻，瓜自己会找上门。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#top"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-white transition hover:bg-primary-600"
              >
                <i className="ri-door-open-line text-lg"></i>
                立即进入瓜房
              </a>
              <a
                href="#today"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 bg-white/10 px-6 py-3 text-sm font-bold text-white transition hover:bg-white/20"
              >
                <i className="ri-list-check-2 text-lg"></i>
                先看今日瓜
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {joinPoints.map((point) => (
              <div
                key={point.id}
                className="rounded-lg border border-white/15 bg-white/10 p-4 backdrop-blur-sm"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-white">
                  <i className={point.icon}></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-white">{point.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-white/70">{point.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}